<template>
  <div id="blog">
    <el-container>
      <el-header v-if="isShowMenu" class="header">
        <img src="./assets/img/logo.svg" />
        <i :class="!isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="changeMenuView"></i>
        <div class="header-right">
          <el-button v-if="isShowBtn" @click="saveContent('draft')">保存草稿</el-button>
          <el-button v-if="isShowBtn" type="primary" @click="saveContent('publish')">发布</el-button>
          <el-dropdown @command="handleCommand">
            <!-- <img :src="profilePicture" class="user-header"> -->
            <img :src="profilePicture" class="user-header" @error="loadfild()" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="blog-home">我的主页</el-dropdown-item>
              <el-dropdown-item command="blog-manage">博客管理</el-dropdown-item>
              <el-dropdown-item command="user-center">个人中心</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-header v-else class="header">
        <i :class="!isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'" class="mobile-icon" @click="changeMenuView"></i>
        <div class="header-right">
          <el-button v-if="isShowBtn" class="mobile-btn" @click="saveContent('draft')">保存草稿</el-button>
          <el-button v-if="isShowBtn" type="primary" @click="saveContent('publish')">发布</el-button>
        </div>
      </el-header>
      <el-container>
        <el-menu v-if="isShowLeftMenu" :default-active="selectedKeys" :collapse="isCollapse" :collapse-transition="false">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-document"></i>
              <span slot="title">内容管理</span>
            </template>
            <el-menu-item index="1-1" @click="clickMenu('/richTextEditor.html')">
              <span slot="title">添加文章</span>
            </el-menu-item>
            <el-menu-item index="1-2" @click="clickMenu('/articleManage.html')">
              <span slot="title">文章管理</span>
            </el-menu-item>
            <el-menu-item index="1-3" v-if="isAdmin" @click="clickMenu('/topicManage.html')">
              <span slot="title">话题管理</span>
            </el-menu-item>
            <el-menu-item index="1-4" @click="clickMenu('/classification.html')">
              <span slot="title">个人分类</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="2" v-if="isAdmin">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span slot="title">博主管理</span>
            </template>
            <el-menu-item index="2-1" @click="clickMenu('/addBlogUser.html')">
              <span slot="title">添加博主</span>
            </el-menu-item>
            <el-menu-item index="2-2" @click="clickMenu('/blogUserList.html')">
              <span slot="title">博主列表</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span slot="title">设置</span>
            </template>
            <el-menu-item v-if="isAdmin" index="3-1" @click="clickMenu('/sensitiveWordsManage.html')">
              <span slot="title">敏感词管理</span>
            </el-menu-item>
            <el-menu-item v-else index="3-2" @click="clickMenu(`/addBlogUser.html?id=${uid}`)">
              <span slot="title">博客设置</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <el-main>
          <router-view ref="target-name"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import $ from 'jquery';
import { mapActions, mapState } from 'vuex';
// import { BlogApi } from './utils/api/blog.api'
import { CookieUtils } from './utils/cookie.utils';
import { get_avatar, isMobile } from './utils/utils';
import user from './assets/img/user.svg';
import { environment } from './environment';
import './assets/common.css';

export default {
  name: 'blogEditor',
  data() {
    return {
      uid: undefined,
      selectedKeys: '',
      isCollapse: false,
      isShowBtn: false,
      profilePicture: user,
      isShowMenu: true,
      isShowLeftMenu: true,
    };
  },
  async created() {
    let uid = CookieUtils.getCookie('SA_USER_UID');
    if (uid) {
      this.uid = uid;
      // 8034435
      this.profilePicture = get_avatar(uid);
      // https://getavatar.caixin.com/008/03/44/35_real_avatar_middle.jpg?timestamp=1641366064372"
      // https://getavatar.caixin.com/008/03/44/35_real_avatar_middle.jpg
      await this.getUserlevel();
      // await this.getUserInfo(uid)
    } else {
      // 去登录
      window.location.href = `https://u.caixin.com/web/login?url=${window.location.href}`;
    }
    if (isMobile()) {
      this.changeMenuView();
      this.isShowLeftMenu = false;
    }
  },
  computed: {
    ...mapState(['isAdmin', 'homeUrl']),
  },
  watch: {
    '$route.path': function(val) {
      console.log(val);
      this.isShowBtn = false;
      this.isShowMenu = true;
      switch (val) {
        case '/richTextEditor.html':
          this.selectedKeys = '1-1';
          this.isShowBtn = true;
          if (isMobile()) {
            this.isShowMenu = false;
          }
          break;
        case '/articleManage.html':
          this.selectedKeys = '1-2';
          break;
        case '/topicManage.html':
          this.selectedKeys = '1-3';
          break;
        case '/classification.html':
          this.selectedKeys = '1-4';
          break;
        case '/addBlogUser.html':
          this.selectedKeys = '2-1';
          break;
        case '/blogUserList.html':
          this.selectedKeys = '2-2';
          break;
        case '/sensitiveWordsManage.html':
          this.selectedKeys = '3-1';
          break;

        default:
          this.selectedKeys = '';
          break;
      }
    },
  },
  methods: {
    ...mapActions(['getUserlevel', 'getUserInfo']),
    changeMenuView() {
      this.isCollapse = !this.isCollapse;
      if (isMobile()) {
        // debugger
        this.isShowLeftMenu = !this.isShowLeftMenu;
        $('.el-main').css('margin-left', '0');
        setTimeout(() => {
          $('#toolbar').css({ width: '85%', left: '8%' });
        }, 500);
      } else {
        if (this.isCollapse) {
          $('.el-main').css('margin-left', '64px');
          $('#toolbar').css({ width: '85%', left: '8%' });
        } else {
          $('.el-main').css('margin-left', '200px');
          $('#toolbar').css({
            width: '70%',
            left: '20%',
          });
        }
      }
    },
    loadfild() {
      this.profilePicture = user;
    },
    handleCommand(val) {
      console.log(val);
      switch (val) {
        // https://xiabing.blog.caixin.com/
        case 'blog-home':
          window.open(this.homeUrl);
          break;
        case 'blog-manage':
          window.open(`${environment.deployUrl}/articleManage.html`);
          // window.open(`${window.location.host}/articleManage.html`)
          break;
        case 'user-center':
          window.open(`//u.caixin.com/web/userinfo`);
          break;
        case 'logout':
          CookieUtils.setCookie('SA_USER_UID', '', -1, '/', '.caixin.com');
          // window.location.href = 'https://gateway.caixin.com/api/ucenter/user/v1/logout'
          // window.location.href = `//u.caixin.com/web/login?url=${window.location.href}`
          window.location.href = `//u.caixin.com/web/login?url=${window.location.origin}${window.location.pathname}`;
          break;

        default:
          break;
      }
    },
    clickMenu(path) {
      // this.isShowBtn = false
      // if(path == '/richTextEditor.html'){
      //   this.isShowBtn = true
      //   this.isShowMenu = false
      // }else{
      //   this.isShowMenu = true
      // }
      if (path == '/richTextEditor.html') {
        window.open(`${environment.deployUrl}/richTextEditor.html`);
      } else {
        this.$router.push({ path: path });
      }
      if (isMobile()) {
        this.changeMenuView();
      }
      // const { href } = this.$router.resolve({
      //   path: path,
      // });
      // window.open(href, "_blank");
    },
    saveContent(type) {
      this.$refs['target-name'].saveContent(type);
    },
  },
};
</script>

<style lang="less" scoped>
#blog {
  width: 100%;
  height: 100%;
  font-family: 'PingFang SC';
  font-size: 14px;
  .header {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1999;
    background-color: #27233b;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    .el-icon-s-unfold,
    .el-icon-s-fold {
      position: absolute;
      left: 160px;
      font-size: 20px;
      color: white;
    }
    .mobile-icon {
      left: 20px;
      top: 20px;
    }
    .header-right {
      display: flex;
      align-items: center;
      .el-button {
        width: 100px;
        height: 30px;
        padding: 0;
      }
      .mobile-btn {
        margin-left: 40px;
      }
      .user-header {
        width: 40px;
        height: 40px;
        margin: 0 20px 0 30px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
  .el-container {
    width: 100%;
    height: 100%;
    .el-menu {
      position: fixed;
      top: 60px;
      height: 100%;
      z-index: 2000;
    }
    .el-menu:not(.el-menu--collapse) {
      width: 200px;
    }
    .el-main {
      padding: 0px;
      width: 100%;
      height: 100%;
      overflow: scroll;
      margin-top: 60px;
      margin-left: 200px;
    }
  }
}
</style>
